// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @20.11.2018 09:54:20
import { SystemProfile_abstract } from './../abstract/SagaBase/SystemProfile_abstract';
export class SystemProfile extends SystemProfile_abstract {}
